import type { Point, Size } from '@view-model/models/common/basic';
import { ForeignObjectAutosize2 } from '@view-model/models/common/components/ForeignObjectAutosize';

type Props = {
  position: Point;
  onSizeChange?: (newSize: Size) => void;
  paddingTop?: number;
  children: React.ReactNode;
};

export const CommentMenuContainer: React.FC<Props> = ({ position, onSizeChange, paddingTop = 24, children }: Props) => {
  const handleSizeChange = (newSize: Size) => {
    onSizeChange?.(newSize);
  };

  return (
    <g transform={position.toSVGTranslate()}>
      <ForeignObjectAutosize2 onSizeChange={handleSizeChange}>
        <div style={{ paddingTop, paddingInline: 15 }}>{children}</div>
      </ForeignObjectAutosize2>
    </g>
  );
};
